import { Button, Typography } from '@arionbanki/arionui';
import { Circle, Footer, Modal, ProgressBar } from 'components';
import { useSign } from './useSign';
import docImage from 'img/doc.png';

export function Sign() {
	const { config, goBack, isSubmited, t, ...ctx } = useSign();
	return !config.IS_EMPLOYEE_WEB ? null : (
		<ProgressBar page="sign">
			{ctx.infoboxMessage && <Typography TagName="p">{t(ctx.infoboxMessage, 'document_signing')}</Typography>}
			<Typography TagName="h3" className="text-secondary">
				{t('signing_title', 'document_signing')}
			</Typography>
			<Typography TagName="p">{t('signing_subtitle', 'document_signing')}</Typography>
			<div className="card card--white mt-4 mb-4">
				<div className="row">
					<div className="col-xs-0 col-sm-0 col-md-2 col-lg-2 col-xl-2">
						<img alt="" className="sign-card-img" src={docImage} />
					</div>
					<div className="col-xs-12 col-sm-8 col-md-7 col-lg-7 col-xl-5">
						<Typography TagName="h6" className="text-secondary">
							{t('signing_agreement', 'document_signing')}
						</Typography>
						{ctx.state.user.givenName}
					</div>
					<div className="col-xs-12 col-sm-4 col-md-3 col-lg-3 col-xl-5 text-right">
						<Button disabled={isSubmited} mode="stroked" onClick={ctx.handleSend}>
							{t('send', 'document_signing')}
						</Button>
						<Button disabled={isSubmited} mode="stroked" onClick={ctx.handlePrint}>
							{t('print', 'document_signing')}
						</Button>
					</div>
				</div>
			</div>
			<div className="card card--grey card--no-shadow mb-4">
				<Typography TagName="h6">
					<Circle>1</Circle>
					{t('signing_p1_title', 'document_signing')}
				</Typography>
				<Typography TagName="p" className="font--16 mb-4">
					{t('signing_p1', 'document_signing')}
				</Typography>
				<Typography TagName="h6">
					<Circle>2</Circle>
					{t('signing_p2_title', 'document_signing')}
				</Typography>
				<Typography TagName="p" className="font--16">
					{t('signing_p2', 'document_signing')}
				</Typography>
			</div>
			<Footer
				handleNext={() => ctx.setIsConfirmModalOpen(true)}
				handlePrev={goBack}
				isDisabled={isSubmited}
				next={t('confirm', 'document_signing')}
				prev={t('back')}
			/>
			<Modal background="dim" isOpen={!!ctx.signedModalMessage} handleClose={() => ctx.setSignedModalMessage('')}>
				<Typography TagName="p">{ctx.signedModalMessage}</Typography>
			</Modal>
			<Modal background="dim" isOpen={ctx.isConfirmModalOpen} handleClose={() => ctx.setIsConfirmModalOpen(false)}>
				<Typography TagName="p">{t('do_you_confirm', 'document_signing')}</Typography>
				<Button mode="primary" onClick={ctx.handleConfirm}>
					{t('confirm_modal_btn', 'document_signing')}
				</Button>
			</Modal>
		</ProgressBar>
	);
}
